import { memo, useMemo } from "react";
import { bool, number, string, func } from "prop-types";
import { useTranslation } from "react-i18next";
import { BreakdownTableDepths } from "@repo/utils";
import { Grid, Switch, Tooltip } from "@material-ui/core";
import useStyle from "./VisibilityCell.style";
import useCellStyle from "../../../../styles/CommonTableCellStyles.style";
import classnames from "classnames";

export const VisibilityCell = memo(({
  onVisibilityToggle,
  actionTargetName,
  tableDepth = BreakdownTableDepths.SECTION,
  visible = true,
  displayToggle,
  isHeader,
  presetClass,
}) => {
  const { t } = useTranslation();
  const classes = useStyle();
  const cellClasses = useCellStyle();

  const text = useMemo(() => (
    `${t(`common.${visible ? "disable" : "enable"}`)} ${(actionTargetName || t(`proposal_parts.module_levels.level_${tableDepth}`)).toLowerCase()}`
  ), [visible, tableDepth, actionTargetName]);

  return (
    <Grid
      item
      container
      role="rowitem"
      alignItems="flex-start"
      className={classnames(
        "pr-0 pl-2 visibilityContainer drag-hide noDrag noExpand",
        "preset-noedit",
        presetClass,
        classes.visibilityCell,
        isHeader && cellClasses.headCell,
      )}
    >
      <Grid
        item container
        alignItems="center"
        wrap="nowrap"
        className={classnames(!isHeader && cellClasses.cellInner)}
      >
        {
          displayToggle &&
          <Tooltip arrow title={text} placement="bottom">
            <Switch
              size="small"
              color="default"
              checked={visible}
              onChange={onVisibilityToggle}
              className="noDrag hoverIcon opq preset-taskActionButton"
              name={text}
              tabIndex={-1}
            />
          </Tooltip>
        }
      </Grid>
    </Grid>
  );
});

VisibilityCell.propTypes = {
  onVisibilityToggle: func,
  actionTargetName: string,
  tableDepth: number,
  visible: bool,
  displayToggle: bool,
  isHeader: bool,
  size: string,
  presetClass: string,
};
